import { useState } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { prettyFloatMoney } from '@/helpers/utils';
import { useGetFundraisingStatusById } from '@/query/queries/fundraising/useGetFundraisingStatusById';
import { FR_STEPS } from '@/helpers/fundraising';
import { GoalEditModal } from '../GoalEditModal';
import IconEdit from '../../assets/icon_edit_black.svg';
import s from './index.module.scss';

export const FundraisingStatus = ({
  newFunds,
  hideTitle,
  mainFounder,
  fundraisingId,
  disabled,
  className,
}) => {
  const [show, setShow] = useState(false);
  const { t } = useTranslation('fundraising');
  const { data: status } = useGetFundraisingStatusById(fundraisingId);

  const refinOnly = status?.max_new_funds === 0;
  const canEdit =
    !disabled && Boolean(mainFounder && status?.step === FR_STEPS.set_goal && status?.max_new_funds > 0);

  const viewMode = status?.step === FR_STEPS.fundraising_summary;

  return (
    <div className={className}>
      {!hideTitle && (
        <h3 className={classnames(s.title, 'f-h3 f-500')}>
          {t('fr_status.fundraising_goal_for_next_round')}
        </h3>
      )}
      <div className={classnames(s.statistics)}>
        {!refinOnly && (
          <div className={classnames(s.row, viewMode && s.row_view, 'f-body')}>
            <div className="f-small-accent">{t('fr_status.new_funds')}</div>
            <div className="f-small-regular">{prettyFloatMoney(newFunds)}</div>
            <div className={s.edit}>
              {canEdit && (
                <button type="button" className={s.btn_edit} onClick={() => setShow(!show)}>
                  <img src={IconEdit} alt="edit" width={24} height={24} />
                </button>
              )}
            </div>
          </div>
        )}

        {status?.refinances?.map(refinance => (
          <div key={refinance.name} className={classnames(s.row, viewMode && s.row_view, 'f-body')}>
            <div className="f-small-accent">
              {t('fr_status.refinance', { name: refinance.name })}
            </div>
            <div className="f-small-regular">{prettyFloatMoney(refinance.amount)}</div>
          </div>
        ))}
        <div className={classnames(s.row, viewMode && s.row_view, s.total, 'f-body')}>
          <div className="f-small-accent">{t('fr_status.total_fundraising_goal')}</div>
          <div className="f-small-accent">{prettyFloatMoney(status?.goal)}</div>
        </div>
      </div>

      {canEdit && show && <GoalEditModal onClose={() => setShow(false)} />}
    </div>
  );
};
